module.exports = __webpack_public_path__ + "media/images/app/ga-3b43e9c294c89621e03bbcd79f1a24a1.svg";